import React from "react"
import { SvgIcon, SvgIconProps } from "@material-ui/core"

export default function Templates(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M11.99 19.0067L4.62 13.2767L3 14.5367L12 21.5367L21 14.5367L19.37 13.2667L11.99 19.0067ZM12 16.4667L19.36 10.7367L21 9.46667L12 2.46667L3 9.46667L4.63 10.7367L12 16.4667ZM12 4.99668L17.74 9.46667L12 13.9367L6.26 9.46667L12 4.99668Z" />
    </SvgIcon>
  )
}
